import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="74" height="34" viewBox="0 0 74 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="74" height="34" rx="4" fill="#7876C1" />
    <rect x="36" width="2" height="34" fill="white" />
    <rect x="17" width="2" height="34" fill="white" />
    <rect x="55" width="2" height="34" fill="white" />
  </svg>
);

const ColumnsFourIcon = (props) => <Icon component={svg} {...props} />;

export default ColumnsFourIcon;
